export default __webpack_public_path__ + "static/media/mv.4f9dea63.png";